module.exports = __webpack_public_path__ + "media/images/aloe/logo/cssninja-9dfe36e8e02f8ad4bbb402c00f885e31.svg";